/* eslint-disable @typescript-eslint/no-empty-function */
import React from "react";
import "./i18n";
import {createRoot} from "react-dom/client";

import "react-toastify/dist/ReactToastify.min.css";
import "./index.css";
import {store} from "./redux/general/reduxStore";
import {Provider} from "react-redux";
import {ToastContainer} from "react-toastify";
import {router} from "./navigation/TaxRouter";
import {RouterProvider} from "react-router-dom";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";

const root = createRoot(document.getElementById("root") as HTMLElement);

if (process.env.NODE_ENV !== "development") {
    console.log = () => {};
    console.debug = () => {};
    console.info = () => {};
    console.warn = () => {};
}
root.render(
    <>
        <ToastContainer
            position="top-right"
            style={{
                marginTop: "56px", // toolbar height
            }}
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
        />
        <Provider store={store}>
            <RouterProvider router={router} />
        </Provider>
    </>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
